import { useEffect, useState } from "react";
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  getKeyValue,
} from "@nextui-org/react";
import { FooterFilterMobile, LoaderCustom } from "../../components";
import { useGetAllRoleApi } from "../../hooks";

export default function RolePage() {
  const [isLoader, setIsLoader] = useState(false);
  const [roleData, setRoleData] = useState([]);

  // api get roles
  const { allRole } = useGetAllRoleApi();

  useEffect(() => {
    setIsLoader(true);

    if (allRole?.data) {
      const rolesConvert = allRole?.data?.map((item: any) => {
        return {
          id: item?.id,
          roleName: item?.name,
          createdAt: item?.createdAt,
          delete: item?.delete,
        };
      });
      setRoleData(rolesConvert);
      setTimeout(() => {
        setIsLoader(false);
      }, 200);
    }
  }, [allRole]);

  return (
    <>
      {isLoader && <LoaderCustom></LoaderCustom>}
      <div className="w-[100%] md:pb-2 p-[16px] md:px-[0px] font-semibold text-ok-travel-green mb-2 border-b-[1.5px] md:mb-4">
        <h3 className="uppercase max-md:mt-4 text-medium text-gray-500 md:text-md xl:text-xl">
          Manage Role
        </h3>
      </div>
      <div className="mt-4 px-[16px] md:px-[0px]">
        <Table
          aria-label="Example table with client side pagination"
          classNames={{
            wrapper: "h-[74vh]",
          }}
        >
          <TableHeader>
            {/* <TableColumn key="id">ID</TableColumn> */}
            <TableColumn key="roleName">ROLE NAME</TableColumn>
            <TableColumn key="createdAt">CREATED AT</TableColumn>
            <TableColumn key="delete">IS ACTIVE</TableColumn>
          </TableHeader>
          <TableBody items={roleData}>
            {(item: any) => (
              <TableRow key={item.id}>
                {(columnKey) => {
                  if (columnKey === "delete") {
                    return (
                      <TableCell className="lg:text-[0.9rem] text-[0.8rem]">
                        {getKeyValue(item, columnKey)
                          ? "Not Active"
                          : "Actived"}
                      </TableCell>
                    );
                  } else if (columnKey === "createdAt") {
                    return (
                      <TableCell className="lg:text-[0.9rem] text-[0.8rem]">
                        {getKeyValue(item, columnKey)
                          ? getKeyValue(item, columnKey)
                          : "No Update"}
                      </TableCell>
                    );
                  } else {
                    return (
                      <TableCell className="lg:text-[0.9rem] text-[0.8rem]">
                        {getKeyValue(item, columnKey)}
                      </TableCell>
                    );
                  }
                }}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
      <FooterFilterMobile></FooterFilterMobile>
    </>
  );
}
